function getCCPAContent() {
  let url
  if (document.getElementById('ccpaContentEndpoint')) {
    url = document
      .getElementById('ccpaContentEndpoint')
      .getAttribute('data-url')
    return fetch(url, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((res) => res.json())
  } else {
    return FakeAGAData
  }
}

const FakeAGAData = new Promise((resolve) => {
  resolve({
    companyName: 'Ohio National',
    headingContentHTML: '<h1>Placeholder for heading Content</h1>',
    contactContentHTML: '<h1>Placeholder for contact Content</h1>'
  })
})

export { getCCPAContent }
